
export const easterCamp = {
  title: "Easter Camp",
  subtitle: "A unique learning and fun experience in contact with nature",
  gallery: {
    title: "Gallery",
    caption: "Moments from our Easter camps",
    images: [
      { src: "/lovable-uploads/patio-futbol-pradera.png", alt: "Children exploring nature" },
      { src: "/lovable-uploads/patio-carpinteria-cana.png", alt: "Outdoor activities" },
      { src: "/lovable-uploads/huerta-charco-barro.png", alt: "Montessori materials" }
    ]
  },
  description: {
    title: "Camp Overview",
    content1: "Our Easter camp offers a variety of activities including cooking workshops, science experiments, outdoor nature play, and creative art with Voadoras. We'll design detailed activities once we know the number of children attending, but we'll send examples of activities and workshops in the coming days.",
    content2: "Our teachers have many cooking ideas and creative activities planned. We'll use materials available at Gándara, creating an environment that encourages exploration, creativity, and fun!"
  },
  activities: {
    title: "Activities and Workshops",
    list: [
      "Cooking workshops tailored for children",
      "Fun and educational science experiments",
      "Nature play and outdoor exploration",
      "Creative art with Voadoras",
      "Clay art projects with textures from everyday objects, natural elements, and recycled materials",
      "Art projects inspired by artist Louise Nevelson, creating sculptures using recycled materials"
    ]
  },
  spaces: {
    title: "Learning Spaces",
    intro: "We'll create different activity corners in the office space:",
    list: [
      {
        title: "READING CORNER",
        description: "A cozy space with a carpet, cushions, and a bookshelf with stories."
      },
      {
        title: "RELAXATION AREA",
        description: "A teepee, carpet, stuffed animals, mattress, and fabrics. Spaces 1 and 2 will be together."
      },
      {
        title: "SYMBOLIC PLAY",
        description: "Kitchen, table, dishes, and props for imaginative play."
      },
      {
        title: "CONSTRUCTION AND MINI-WORLDS",
        description: "All construction materials (magnetics, wooden pieces...), containers with loose parts."
      },
      {
        title: "ARTISTIC CORNER",
        description: "A small table from Early Childhood and a small shelf with art materials."
      }
    ]
  },
  schedule: {
    title: "Daily Schedule",
    list: [
      "Arrival and free play",
      "Assembly and introduction to the day",
      "Workshop",
      "Snack time",
      "Free play",
      "Workshop",
      "Final assembly and relaxation"
    ]
  },
  prices: {
    title: "Prices",
    headers: {
      fullCamp: "4 Days",
      singleDay: "Single Day",
      earlyBird: "Early Drop-off",
      lunch: "Lunch"
    },
    students: "Gándara Students",
    external: "External Students"
  },
  contact: {
    title: "Contact Us",
    button: "Book a Visit"
  }
};

export const christmasCamp = {
  title: "Christmas Camp",
  subtitle: "A camp where free play, curiosity and creativity guide each day, with close and respectful accompaniment",
  gallery: {
    title: "Gallery",
    caption: "Magical moments from our Christmas camp",
    images: [
      { src: "/lovable-uploads/christmas-camp-poster.jpg", alt: "Christmas Camp Poster" }
    ]
  },
  description: {
    title: "Camp Overview",
    content1: "Celebrate the holidays with us in a magical atmosphere where children can enjoy creative activities, Christmas workshops and moments of free play.",
    content2: "Our team of facilitators creates a safe and respectful space where each child can explore, create and have fun at their own pace."
  },
  activities: {
    title: "Activities",
    list: [
      "Creative Christmas workshops",
      "Healthy cooking and seasonal recipes",
      "Art and sensory expression workshops",
      "Free play and exploration",
      "Outdoor activities",
      "Storytelling and music"
    ]
  },
  schedule: {
    title: "Dates and Schedule",
    dates: "December 22, 2026 to January 7, 2027",
    note: "(except holidays)",
    hours: "Schedule: 9:00 AM - 2:00 PM",
    extended: "Extended: 8:30 AM - 3:30 PM",
    ages: "Ages: 3 to 12 years"
  },
  prices: {
    title: "Prices",
    members: "Gándara Members",
    nonMembers: "Non-members",
    oneWeek: "1 Week",
    complete: "Complete"
  },
  contact: {
    title: "Reserve your spot!",
    button: "Register"
  }
};

export const summerCamp = {
  title: "Summer Camp 2026",
  subtitle: "Join us for an unforgettable experience at Gándara International School's summer camp",
  gallery: {
    title: "Gallery",
    caption: "Moments from our summer camps",
    images: [
      { src: "/lovable-uploads/86807e57-9b48-4117-811e-2178c1e55e7d.png", alt: "Children playing outdoors" },
      { src: "/lovable-uploads/4fb227e3-a5f5-4a84-94b3-bdbd9ebd058b.png", alt: "Exploring nature" },
      { src: "/lovable-uploads/b8f5b9b1-cac2-4895-b283-d2a0df3dbed9.png", alt: "Creative activities" }
    ]
  },
  intro: "This summer, at Gándara International School, we're opening our doors to an unforgettable experience: a unique camp where nature, play, and emotional development intertwine to offer each child a summer full of magic, discovery, and personal growth.",
  educationalProposal: {
    title: "A Different Educational Approach",
    content: "At Gándara International School, we believe that a bright future begins with a childhood lived to the fullest. Our camp is not just a leisure space, but a comprehensive educational experience, in an environment where children can:",
    items: [
      "Reconnect with nature and their own inner rhythm.",
      "Discover the world through play, emotion, and curiosity.",
      "Feel heard, accompanied, and respected."
    ],
    additional: "Each day is an opportunity to grow, imagine, explore, learn, and share. This camp stems from Gándara International School's pedagogical commitment, integrating methodologies such as:",
    methodologies: [
      "Education in nature (forest school and English learning)",
      "STEM proposals to awaken logical and scientific thinking",
      "Reading activities, stories, and creative writing to nurture language, expression, and imagination"
    ],
    conclusion: "A combination that drives both active learning and emotional and social development.",
    workshopsTitle: "Weekly themed workshops",
    workshops: [
      { day: "Monday", activity: "Art" },
      { day: "Tuesday", activity: "Crafts" },
      { day: "Wednesday", activity: "Cooking" },
      { day: "Thursday", activity: "Experiments & children's proposals" },
      { day: "Friday", activity: "Outings" }
    ],
    workshopsNote: "Workshops are not mandatory and may be modified based on participants."
  },
  principles: {
    title: "Our Pedagogical Principles",
    list: [
      "Connection with nature through direct experience",
      "Free play as a basis for learning",
      "Individualized and respectful accompaniment",
      "Dynamics that foster empathy, cooperation, and self-regulation",
      "Meaningful activities to develop practical and emotional intelligence",
      "Spaces to grow with confidence, autonomy, and joy",
      "Fostering scientific curiosity and logical thinking through STEM proposals adapted to each stage"
    ]
  },
  audience: {
    title: "Who Is It For?",
    ageGroups: "Children ages 3 to 12",
    ratio: "Ratio 1:14",
    note: "We work with small groups, ensuring personalized attention and close accompaniment."
  },
  location: {
    title: "Prime Location",
    name: "Gándara International School",
    address: "Gondomar (Pontevedra)",
    description: "A natural rural environment, safe and full of possibilities:",
    features: [
      "Spacious outdoor gardens with swimming pool",
      "Multipurpose rooms for workshops and quiet activities",
      "Kitchen, bathrooms, and covered areas adapted for children and weather conditions",
      "Active school garden throughout summer"
    ]
  },
  schedule: {
    title: "Dates and Schedule",
    dates: "From June 22 to September 4, 2026",
    days: "Monday to Friday, morning schedule",
    holidays: "Holidays: June 24 (regional holiday) and August 17 (local holiday)",
    timetable: {
      title: "Typical Schedule:",
      slots: [
        { time: "09:00 - 10:00", activity: "Flexible arrival" },
        { time: "10:00 - 10:30", activity: "Morning circle: introduction to the day's workshop and sharing time" },
        { time: "10:30 - 11:30", activity: "Themed workshop of the day" },
        { time: "11:30 - 12:00", activity: "Snack" },
        { time: "12:00 - 13:30", activity: "Free play, including swimming pool" },
        { time: "13:30 - 14:00", activity: "Cleanup and farewell" },
        { time: "14:00 - 15:30", activity: "Lunch (bring your own lunch box)" }
      ]
    }
  },
  included: {
    title: "What's Included in the Camp?",
    items: [
      "Daily themed workshops (art, crafts, cooking, experiments, outings)",
      "Free play and swimming pool time",
      "Educational and creative materials",
      "Respectful accompaniment by qualified professionals",
      "Civil liability and accident insurance",
      "Optional lunch service (with lunch box from home)",
      "Optional extended hours: early drop-off and late pickup"
    ]
  },
  toBring: {
    title: "What Should Children Bring?",
    items: [
      "Comfortable clothes that can get dirty",
      "Backpack with water bottle and snack",
      "Cap and sun protection",
      "Towel and swimwear (for the pool)",
      "Change of clothes",
      "Raincoat (in case of rain)"
    ],
    note: "Everything labeled with their name to avoid loss."
  },
  registration: {
    cta: "Register now",
    title: "Registration",
    limitedSpots: "Limited spots!",
    options: "You can register by week or for the entire summer.",
    form: {
      title: "Registration Form",
      parentInfo: "Parent/Guardian Information",
      childInfo: "Child Information",
      weeksSelection: "Weeks Selection",
      options: "Additional Options",
      membership: "Gándara Membership",
      submit: "Submit Registration"
    }
  },
  pricing: {
    title: "Pricing",
    weeks: {
      oneWeek: "1 Week",
      twoWeeks: "2 Weeks",
      threeWeeks: "3 Weeks",
      fourWeeks: "4 Weeks",
      fiveWeeks: "5 Weeks"
    },
    members: "Gándara Members",
    nonMembers: "Non-members",
    options: {
      lunch: "Lunch (bring your own lunch box)",
      earlyDropoff: "Early Drop-off",
      latePickup: "Late Pickup"
    },
    labels: {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      perSection: "Per section"
    },
    discounts: {
      title: "Sibling discounts",
      secondChild: "10% off for the 2nd child",
      thirdChild: "25% off for the 3rd child and beyond"
    }
  },
  faq: {
    title: "Frequently Asked Questions",
    questions: [
      {
        question: "What ages can participate in the camp?",
        answer: "Children from 3 to 12 years old can participate, with a ratio of 1:14."
      },
      {
        question: "What if my child has dietary restrictions?",
        answer: "Please indicate any allergies or dietary restrictions on the registration form, and we'll accommodate them accordingly."
      },
      {
        question: "What is the cancellation policy?",
        answer: "Cancellations made up to two weeks before the start date receive a full refund. Cancellations within two weeks of the start date receive a 50% refund. No refunds for cancellations within 72 hours of the start date."
      },
      {
        question: "Are the workshops mandatory?",
        answer: "No, the workshops are not mandatory. Children can participate freely and activities may be modified based on participants."
      }
    ]
  }
};

export const summerCampConfirmation = {
  title: "Registration Submitted!",
  subtitle: "We have received your summer camp registration. You will receive a confirmation email shortly.",
  contactTitle: "Need to contact us?",
  contact: {
    phone: "Phone",
    email: "Email",
  },
  backToCamp: "Back to camp",
  backToHome: "Back to home",
  note: "If you don't receive a confirmation email, please check your spam folder or contact us directly.",
};
